// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.CredentialIssuer
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.wallet.shared.CredentialIssuerOpenID4VCI

fun CredentialIssuer.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Naiag5erAqEaBYz9EMl_DUyuNqg1nHllTiJyK7CPWXA")
val CredentialIssuer_cborSchemaId = ByteString(53, -88, -102, -125, -105, -85, 2, -95, 26, 5, -116, -3, 16, -55, 127, 13, 76, -82, 54, -88, 53, -100, 121, 101, 78, 34, 114, 43, -80, -113, 89, 112)

fun CredentialIssuer.Companion.fromCbor(data: ByteArray): CredentialIssuer {
    return CredentialIssuer.fromDataItem(Cbor.decode(data))
}

val CredentialIssuer.Companion.cborSchemaId: ByteString
    get() = CredentialIssuer_cborSchemaId

fun CredentialIssuer.toDataItem(): DataItem {
    return when (this) {
        is CredentialIssuerOpenID4VCI -> (this as CredentialIssuerOpenID4VCI).toDataItem()
    }
}

fun CredentialIssuer.Companion.fromDataItem(dataItem: DataItem): CredentialIssuer {
    val type = dataItem["type"].asTstr
    return when (type) {
        "OpenID4VCI" -> CredentialIssuerOpenID4VCI_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
